"use strict";

/**
 * @classdesc
 * Container-Modul für eine Sammlung von Werkzeugen.
 *
 * @class
 * @extends gc.gis.module.GCAbstractContainerModule
 * @memberof gc.gis.module
 * @author Christian Schmidt <c.schmidt@brain-scc.de>
 *
 * @param {Object} options Aufrufoptionen
 * @param {string} options.alias
 * @param {string} options.target
 * @param {string} [options.label='Werkzeuge']
 */
gc.gis.module.GCTools = function (options)
{
    options.label = options.label || 'Werkzeuge';
    options.icon = 'ms ms-tools';

    gc.gis.module.GCAbstractContainerModule.call(this, options);

    this._render();
};
gc.gis.module.GCTools.prototype = Object.create(gc.gis.module.GCAbstractContainerModule.prototype);
